import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import {
  createCommandAsyncThunk,
  createQueryAsyncThunk,
} from "../../app/createApiAsyncThunk";
import { RootState } from "../../app/store";
import {
  AddOrderBundleComment,
  getOrderBundleComments,
  OrderBundleComment,
  OrderBundleCommentAdded,
  OrderBundleCommentUpdated,
  postAddOrderBundleComment,
  postRemoveOrderBundleComment,
  postUpdateOrderBundleComment,
  RemoveOrderBundleComment,
  UpdateOrderBundleComment,
} from "./orderAPI";

const orderBundleCommentsAdapter = createEntityAdapter<OrderBundleComment>({
  sortComparer: (a, b) => b.dateTime - a.dateTime,
});

export const fetchOrderBundleComments = createQueryAsyncThunk<
  OrderBundleComment[],
  { bundleId: string }
>("orders/fetchOrderBundleComments", getOrderBundleComments);

export const addOrderBundleComment = createCommandAsyncThunk<
  AddOrderBundleComment,
  OrderBundleCommentAdded
>("orders/addOrderBundleComment", postAddOrderBundleComment);

export const updateOrderBundleComment = createCommandAsyncThunk<
  UpdateOrderBundleComment,
  OrderBundleCommentUpdated
>("orders/updateOrderBundleComment", postUpdateOrderBundleComment);

export const removeOrderBundleComment = createCommandAsyncThunk<
  RemoveOrderBundleComment,
  {}
>("orders/removeOrderBundleComment", postRemoveOrderBundleComment);

export const orderBundleCommentsSlice = createSlice({
  name: "orderBundleComments",
  initialState: orderBundleCommentsAdapter.getInitialState({
    status: "idle" as "idle" | "pending" | "succeeded" | "failed",
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderBundleComments.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchOrderBundleComments.fulfilled, (state, action) => {
        orderBundleCommentsAdapter.setAll(state, action.payload);
        state.status = "succeeded";
      })
      .addCase(fetchOrderBundleComments.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { selectAll: selectAllOrderBundleComments } =
  orderBundleCommentsAdapter.getSelectors(
    (state: RootState) => state.orderBundleComments,
  );

export const orderBundleCommentsReducer = orderBundleCommentsSlice.reducer;
